import { useState, useEffect } from 'react';

export const useTimer = (limitMinutes: number) => {

  const [seconds, setSeconds] = useState(0);

  useEffect(() => {

    
    const intervalID = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds + 1);
    }, 1000);

    const minutes = limitMinutes - 1 - Math.floor(seconds / 60);
    const isFinished = seconds >= limitMinutes * 60 && minutes < 0;  

    if(isFinished) return clearInterval(intervalID)

    return () => {
      clearInterval(intervalID);
    };
  }, []);

  const minutes = limitMinutes - 1 - Math.floor(seconds / 60);
  const remainingSeconds = 60 - seconds % 60 - 1;
  const isFinished = seconds >= limitMinutes * 60 && minutes < 0;  

  return {
    minutes: isFinished ? 0 : minutes,
    seconds: isFinished ? 0 : remainingSeconds,
    isFinished,
  };
}